import { AlarmLight, RefreshLight } from '@profgeosoft-ui/icons';
import { Button, Tooltip } from '@profgeosoft-ui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Cross from 'src/shared/assets/icons/cross.svg';
import UploadIcon from 'src/shared/assets/icons/upload-arrow.svg';
import { IconButton } from 'src/shared/components/icon-button';
import { Loader } from 'src/shared/components/loader';
import { useStore } from 'src/store';

import { ExportStore } from './export-store';

import styles from './export.module.scss';

type Props = {
  exportStore: ExportStore;
};

export const ExportButton = observer<Props>(function ExportButton({ exportStore }) {
  const { t } = useTranslation('drillingCarpet');
  const { comparison, editing } = useStore();
  const { error, isImporting, setIsModalOpen, cancelImport, export: exportFn } = exportStore;

  const toltipTitleRender = useMemo(() => {
    if (error) {
      return (
        <div className={styles.tooltipContentWrapper}>
          <p className={styles.tooltipErrorText}>{t(error)}</p>

          <div className={styles.tooltipContentButtonsWrapper}>
            <Button
              icon={<RefreshLight className={styles.icon_refresh} />}
              className={styles.tooltipContentButton}
              variant="success"
              size="s"
              onClick={exportFn}
            />
            <Button
              className={styles.tooltipContentButton}
              variant="flat"
              size="s"
              onClick={() => setIsModalOpen(true)}
            >
              Изменить параметры экспорта
            </Button>
          </div>
        </div>
      );
    }

    return t('common:export');
  }, [error, exportFn, setIsModalOpen, t]);

  if (isImporting) {
    return (
      <div className={clsx(styles.loaderAndAbortButtonWrapper)}>
        <Loader size="small" className={styles.exportLoader} />
        <IconButton icon={<Cross />} onClick={cancelImport} className={styles.abortButton} />
      </div>
    );
  }

  return (
    <Tooltip title={toltipTitleRender}>
      <Button
        variant="flat"
        icon={
          error ? (
            <AlarmLight className={clsx(styles.icon, styles.icon_error)} />
          ) : (
            <UploadIcon className={styles.icon} />
          )
        }
        disabled={comparison.isComparing || editing.isEditing}
        className={clsx(styles.iconButton, comparison.isComparing && styles.hidden)}
        onClick={error ? undefined : () => setIsModalOpen(true)}
      />
    </Tooltip>
  );
});
